import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardAlias: 'Name of the card',
    cardAliasSuccessfullyUpdated: 'Card name has been successfully updated!',
    maximumCharacters: 'maximum characters',
    ok: 'Ok',
    premium: 'Premium',
  },
  fr: {
    cardAlias: 'Nom de la carte',
    cardAliasSuccessfullyUpdated:
      'Le nom de la carte a été enregistré avec succès !',
    maximumCharacters: 'caractères maximum',
    ok: 'Ok',
    premium: 'Premium',
  },
} as const);

export default locales;
